import React from 'react';
interface ToggleProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  description?: string;
  disabled?: boolean;
}
export const Toggle: React.FC<ToggleProps> = ({
  label,
  checked,
  onChange,
  description,
  disabled = false
}) => {
  return <div className="flex items-center justify-between" data-id="element-1259">
      <div className="flex flex-col" data-id="element-1260">
        <span className="text-sm font-medium text-gray-900" data-id="element-1261">{label}</span>
        {description && <span className="text-xs text-gray-500" data-id="element-1262">{description}</span>}
      </div>
      <button type="button" role="switch" aria-checked={checked} disabled={disabled} onClick={() => !disabled && onChange(!checked)} className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-greenback focus:ring-offset-2 ${checked ? 'bg-greenback' : 'bg-gray-200'} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`} data-id="element-1263">
        <span aria-hidden="true" className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${checked ? 'translate-x-5' : 'translate-x-0'}`} data-id="element-1264" />
      </button>
    </div>;
};